import { ref } from '@vue/composition-api'

import axios from 'axios'

import Document from '@/components/Document/Document'
import useRequest from '@/compositions/useRequest'

const documentTypes = [
  {
    title: 'ЭСМ-2',
    value: 'ESM2',
  },
  {
    title: 'ЭСМ-7',
    value: 'ESM7',
  },
  {
    title: 'Авансовый счет',
    value: 'Schet_oplatu',
  },
  {
    title: 'Типовой договор',
    value: 'DA_docx',
  },
  {
    title: 'Путевой лист для автокрана',
    value: 'PLA',
  },
]

export default {
  props: {
    orderId: Number,
  },
  components: { Document },

  setup(props, context) {
    const { refs } = context
    const dialog = ref(false)
    const documentType = ref(documentTypes[0])

    const fetchFile = () => axios.get(`${process.env.VUE_APP_API_URL}/cabinet/orders/${props.orderId}/documents/generate`, {
      responseType: 'blob',
      headers: {
        Authorization: localStorage.getItem('token'),
      },
      params: {
        type_report: documentType.value.value,
      },
    })

    const { makeRequest, loading } = useRequest({
      context,
      request: () => fetchFile(),
    })

    const submit = async () => {
      const { headers, data } = await makeRequest()

      const blob = new Blob([data], { type: headers['content-type'] })
      const url = URL.createObjectURL(blob)

      refs.linkRef.download = documentType.value.title
      refs.linkRef.href = url
      refs.linkRef.click()
    }

    return {
      loading,
      dialog,
      submit,
      documentType,
      documentTypes,
      console,
    }
  },
}
